module.exports = __webpack_public_path__ + "static/media/applied-coupon.0daaec14.svg";